"use client";

import {Box, Text} from "@chakra-ui/react";
import ScreenshotCreatedAutomatically from "./images/created_automatically.png";
import ScreenshotSync from "./images/sync.png";
import ScreenshotStructure from "./images/structure.png";
import {Container} from "../../components/Container";
import Heading from "../../components/Heading";
import {DocumentArrowUpIcon, LightBulbIcon, UsersIcon} from "@heroicons/react/24/outline";
import {FeatureCarousel, FeatureT} from "../../components/FeatureCarousel";

const features: FeatureT[] = [
  {
    name: "Instant Results",
    summary: "Up and running on the same day",
    description: (
      <>
        Platformed pulls information from across your organisation. You can be up and running in just a few clicks, and
        be automation-ready in under 24 hours.
      </>
    ),
    image: ScreenshotSync,
    icon: LightBulbIcon,
  },
  {
    name: "Empower Your Team",
    summary: "Knowledge at your fingertips",
    description: (
      <>
        Platformed surfaces information to your team where and when they need it to build trust with prospects, partners
        and customers.
      </>
    ),
    image: ScreenshotCreatedAutomatically,
    icon: DocumentArrowUpIcon,
  },
  {
    name: "Infinitely Scalable",
    summary: "Built for businesses of all sizes",
    description:
      "With the ability to set product and configuration level scoping, Platformed Graph works when selling one product or thousands, across multiple entities, jurisdictions or configurations.",
    image: ScreenshotStructure,
    icon: UsersIcon,
  },
];

const SecondaryFeatures = () => (
  <Box
    as="section"
    id="secondary-features"
    aria-label="Features for simplifying everyday business tasks"
    pt={[20, 32]}
    pb={[14, 20, 20, 32]}
  >
    <Container>
      <Box mx="auto" maxW={["2xl", "2xl", "2xl", "3xl"]} textAlign={[null, null, "center"]} mb={16}>
        <Heading size={["2xl", "2xl", "2xl", "3xl"]} pb="1" color="gray.700">
          A knowledge base{" "}
          <Text
            as="span"
            color="green.500"
            bgGradient="linear-gradient(170deg, {colors.teal.400}, {colors.green.500})"
            backgroundClip="text"
          >
            without the hassle
          </Text>
        </Heading>
        <Text mt={4} color="gray.700" fontSize="md">
          Graph automatically builds and maintains your library with information from your whole organization. So you
          can spend your time doing your job, not maintaining your knowledgebase.
        </Text>
      </Box>
      <FeatureCarousel features={features} colorPalette="green" />
    </Container>
  </Box>
);

export default SecondaryFeatures;
